import React from "react";
import Navbar from './Navbar'
import "./App.css";
import Banner from "./Banner"
import requests from "./requests";
import Row from "./Row";
//https://netflix-clone-edd99.web.app/
//fbce6ae1d3654fc561cd9d5400a12038
function App() {
  return (
    <div className="App">
      <Navbar/>
      <Banner/>
      <Row
        title="NETFLIX ORIGNALS"
        fetchUrl={requests.fetchNetflixOrignals}
        isLargeRow={true}
      />
      <Row title="Trending Now" fetchUrl={requests.fetchTrending} />
      <Row title="Top Rated" fetchUrl={requests.fetchTopRated} />
      <Row title="Action Movies" fetchUrl={requests.fetchActionMovies} />
      <Row title="Romance Movies" fetchUrl={requests.fetchRomanceMovies} />
      <Row title="Comedy Movies" fetchUrl={requests.fetchComedyMovies} />
      <Row title="Documentaries" fetchUrl={requests.fetchDocumentaries} />
      <Row title="Horror Movies" fetchUrl={requests.fetchHorrorMovies} />
    </div>
  );
}

export default App;
